import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

type Props = {
  onClose: () => void;
  open: boolean;
};

type State = {
  disabled: boolean;
  showHomepageModal: boolean;
};

class CompanyModal extends React.Component<Props, State> {
  public state = {
    disabled: false,
    showHomepageModal: false,
  };

  public render() {
    // get data
    const { open } = this.props;

    return (
      <Dialog
        onClose={this.handleClose}
        aria-labelledby="homepage-modal-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle id="homepage-modal-dialog-title" style={{ background: '#dce7f1' }}>
          Your personal data
        </DialogTitle>
        <IconButton
          onClick={this.handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ background: '#dce7f1' }}>
          <p>
            This website does <b>not</b> collect any personal data and has:{' '}
          </p>
          <li style={{ marginLeft: '30px' }}>
            <b>No</b> cookies and other persistent identifiers
          </li>
          <li style={{ marginLeft: '30px' }}>
            <b>No</b> connection to the adtech and surveillance capitalism
          </li>
          <li style={{ marginLeft: '30px' }}>
            <b>No</b> cross-site or cross-device tracking
          </li>
          <p />
          <br />
        </DialogContent>
      </Dialog>
    );
  }

  private handleClose = () => {
    this.setState({ disabled: false, showHomepageModal: false });
    this.props.onClose();
  };
}

export default CompanyModal;
